module.exports = __webpack_public_path__ + "img/LogoTremendas7.b8af0bf6.png";